import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_WEB_API_URL;

export const postUserVehicle = async ({
	vehicleYearId,
	makeId,
	modelId,
	yearId,
	variantId
}) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/userVehicle`, retry: true });

		const requestUrl = ``;

		const body = {
			vehicleYearId,
			makeId,
			modelId,
			yearId,
			variantId
		};

		return await instance
			.post(requestUrl, body)
			.then((response) => {
				if (response.status === 200 || response.status === 204)
					return {
						error: false,
						success: true
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const deleteUserVehicle = async ({
	userVehicleId
}) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/userVehicle`, retry: true });

		const requestUrl = `/${userVehicleId}`;

		return await instance
			.delete(requestUrl)
			.then((response) => {
				if (response.status === 204)
					return {
						error: false,
						success: true
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const putActivateUserVehicle = async ({
                                            userVehicleId
                                        }) => {
    try {
        const instance = createApiInstance({ baseURL: `${url}/api/userVehicle/`, retry: true });

        const requestUrl = `activate/${userVehicleId}`;

        return await instance
            .put(requestUrl)
            .then((response) => {
                if (response.status === 204)
                    return {
                        error: false,
                        success: true
                    };
                else
                    return {
                        error: true,
                        success: false,
                        message: response.data.message
                    };
            })
            .catch((error) => {
                if (error.response) {
                    console.error("Server Error:", error.response.status);
                }
                else if (error.request) {
                    console.error("Network Error:", error.request);
                }
                else {
                    console.error("Error:", error.message);
                }
            });
    }
    catch (e) {
        return {
            error: true,
            success: false,
            message: "Something went wrong. Please try again."
        };
    }
};